<ion-content (touchstart)="onTouchStart($event)"
	(touchmove)="onTouchMove($event)"
	(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/common/logo.svg" alt="Logo">
			</header>

			<div class="main">
				<div class="mr-potty">
					<img src="assets/images/report-card/mr_potty_thumbs_up.svg" alt="Mr Potty">
				</div>

				<div class="mr-potty-hands">
					<img class="mr-potty-invisible" src="assets/images/report-card/mr_potty_thumbs_up.svg"
						alt="Mr Potty">
					<img class="left-arm" src="assets/images/report-card/thumbs_up_left_armin.svg" alt="Left Arm">
					<img class="right-arm" src="assets/images/report-card/thumbs_up_right_arm.svg" alt="Right Arm">
					<div class="bubble">
						<img src="assets/images/common/bubble.svg" alt="Bubble">
						<p class="bubble__text">Good or bad... we want to know!</p>
					</div>
				</div>

				<div class="main-content">
					<h2 class="title">Rate your experience</h2>

					<app-progress-bar [activeStep]="7"></app-progress-bar>

					<div class="rating">
						<div class="rating__circle">
							<span>{{ normalizedOverallRating }} <small class="rating-denominator"> / 5</small></span>
							<img class="circle-star" src="assets/images/report-card/star.svg" alt="Star">
						</div>
						<h4 class="rating__text">Overall Star Rating</h4>
					</div>


					<div #categoriesWrapper class="categories-wrapper">
						<div class="categories">
							<app-rating *ngFor="let ratingData of dataForRatings" [title]="ratingData.title"
								[messages]="ratingData.messages" [shadowElement]="shadow"
								[initialRating]="getRatingForCategory(ratingData.title)"
								(ratingChanged)="handleOverallRatingState($event)"
								(selectedRatingTitle)="markRatingAsSelected($event)"
								(individualRatingChange)="trackIndividualCategoryRating($event)"></app-rating>
						</div>
						<div class="shadow" #shadow></div>
					</div>

				</div>

				<app-navigation-buttons
					#navigationButtons
					[nextButtonText]="forwardButtonText"
					[isSkipButtonHidden]="true"
					[isEndOfNoteFlow]="true"
					[isSkipDisplayed]="noteService.totalReportCardRating === 0"
					[componentIdentifier]="6"
					(successSubmit)="showSuccessModal()"
				></app-navigation-buttons>

			</div>
		</div>
	</div>

	<app-error-modal [isModalVisible]="errorModalService.isModalVisible"
		(closeSidebar)="errorModalService.closeErrorModal()">
	</app-error-modal>

	<app-success-modal *ngIf="isSuccessModalVisible" @fadeInOut (click)="closeSuccessModal()"></app-success-modal>
</ion-content>
